export const displayMetalTextComponentNameMap = {
  default: "MetalTextDefault",
  commemorative_license_plate: "MetalTextCommemorativeLicensePlate",
  commemorative_doorplate: "MetalTextCommemorativeDoorplate",
  commemorative_medal: "MetalTextCommemorativeMedal",
};
